export default __webpack_public_path__ + "static/media/wot2watch.259dc359.png";